import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment-timezone';

import TextInput from '../textinput';

import { omitEmptyProps } from '../../services/helpers';

import 'react-day-picker/lib/style.css';

const DEFAULT_PAGE_SIZE = 200;

const SystemLogFilters = ({ filterLogs, pageSizes }) => {
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

    const onInputChange = e => {
        const { value } = e.target;

        setSearch(value);
    };

    const onPageSizeChange = e => {
        const { value } = e.target;

        setPageSize(value);
    };

    const onSearch = e => {
        e.preventDefault();

        const filters = omitEmptyProps({
            dateFrom: dateFrom ? moment(dateFrom).startOf('day').toISOString() : null,
            dateTo: dateTo ? moment(dateTo).endOf('day').toISOString() : null,
            search,
            pageSize,
        });

        filterLogs(filters);
    };

    const onClear = e => {
        e.preventDefault();

        setDateFrom('');
        setDateTo('');
        setSearch('');
        setPageSize(DEFAULT_PAGE_SIZE);

        filterLogs({ pageSize: DEFAULT_PAGE_SIZE });
    };

    return (
        <form className="systemlog-filters">
            <div className="filters-container">
                <div className="input-container field-wrap">
                    <label className="active">Date From</label>
                    <DayPickerInput onDayChange={setDateFrom} value={dateFrom} />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Date To</label>
                    <DayPickerInput onDayChange={setDateTo} value={dateTo} />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Search</label>
                    <TextInput name="search" value={search} onChange={onInputChange} />
                </div>
                <div className="input-container field-wrap">
                    <label className="active">Page size</label>
                    <Scroll.Element name="intent" />
                    <select name="product_id" onChange={onPageSizeChange} value={pageSize}>
                        {pageSizes.map(size => (
                            <option key={size}>{size}</option>
                        ))}
                    </select>
                </div>
            </div>
            <button type="submit" className="button" onClick={onClear}>
                Clear filters
            </button>
            <button type="submit" className="button" onClick={onSearch}>
                Search
            </button>
        </form>
    );
};

SystemLogFilters.propTypes = {
    filterLogs: PropTypes.func.isRequired,
    pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default SystemLogFilters;



// WEBPACK FOOTER //
// ./source/components/systemLogs/systemLogsFilters.js